var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[(!_vm.permissions.workflow)?_c('b-row',{staticClass:"mb-4"},[_c('b-col',[_vm._v(" Access only for RRIC Admins ")])],1):_vm._e(),(_vm.permissions.workflow)?_c('b-row',{staticClass:"mb-4"},[_c('b-col',[_vm._v(" fff ")])],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }